import {useMemo} from "react";
import {useDebouncedValue} from "@mantine/hooks";
import {chatApi} from "../chatApi";
import {couldBeTriggerSearch, isTriggerWordOnly} from "../utils/triggerWordUtils";

/**
 * Debounced trigger word detection via the ContainingTriggerWords API.
 * Used for visual feedback in the input while typing.
 *
 * NOTE: The actual routing decision on submit is handled separately
 * in ChatSplashView via a fresh, non-debounced API call.
 */
export function useTriggerWordDetection(value: string) {
    const [debouncedValue] = useDebouncedValue(value || "", 300);
    const {data: triggerWords} = chatApi.endpoints.containTriggerWord.useQuery(
        debouncedValue,
        {skip: !debouncedValue || debouncedValue.length < 3 || !couldBeTriggerSearch(debouncedValue)}
    );

    const isTriggerSearch = useMemo(
        () => isTriggerWordOnly(value, triggerWords ?? []),
        [triggerWords, value]
    );

    return {isTriggerSearch, triggerWords};
}
